
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/frontend-dev/page/[id]",
      function () {
        return require("private-next-pages/cases/frontend-dev/page/[id].tsx");
      }
    ]);
  